import AppPage from '@common/hoc/AppPage';
import asyncComponent from '@common/utility/asyncComponent';
import React from 'react';

const SecurityPage = asyncComponent(() => import('../../../modules/security'));
export default AppPage(() => <SecurityPage />);
